import { createSlice } from "@reduxjs/toolkit";

type WhitelabelType = {
  whitelabel: string;
};
const initialState: WhitelabelType = {
  whitelabel: ""
};
export const AppStatusSlice = createSlice({
  name: "whitelabel",
  initialState,
  reducers: {
    setWhitelabel: (state, action) => {
      state.whitelabel = action.payload;
    }
  }
});

export const { setWhitelabel } = AppStatusSlice.actions;

export default AppStatusSlice.reducer;
